import * as React from "react";
import {
  Box,
  Typography,
  Modal,
  Table,
  TableBody,
  TableCell,
  TextareaAutosize,
  Button,
  Grid,
  Paper,
  Tooltip,
  Pagination,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { AiFillCloseSquare } from "react-icons/ai";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import AxiosInstance from "../apis/AxiosInstance";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  boxShadow: "none",
  color: theme.palette.text.secondary,
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50vw",
  bgcolor: "background.paper",
  border: "2px solid #000",
  p: 2,
  height: "auto",
  zIndex: "999",
};

export default function CommentDetails(props) {
  const Navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [appointment_id, setAppontment_id] = useState(props.lead_id);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setComment("");
  };

  const btnstyle = {
    margin: "8px 0",
    backgroundColor: "#06113C",
    color: "#fff",
    border: "1px solid #06113C",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    let formData = new FormData();

    const token = Cookies.get("logged");

    formData.append("id", props.lead_id);
    formData.append("user_comment", comment);

    try {
      await AxiosInstance.patch("/edit_lead_passing", formData, config)
        .then((response) => {
          if (response.status === 200) {
            toast.success("User Comment Updated");
            setTimeout(() => {
              window.location.href = "/lead_passing_form_list";
              setOpen(false);
              setComment("");
            }, 1000);
          }
        })
        .catch((error) => {
          toast.error(error.response.data.error);
          console.log(error);
        });
    } catch (error) {
      console.log(error.message);
    }
  };

  return (
    <div>
      <Tooltip title="User Comment">
        <Button
          size="small"
          onClick={handleOpen}
          sx={{
            "&:hover": { background: "#003161" },
            backgroundColor: "#003161",
            color: "#fff",
          }}
        >
         Add Comment
        </Button>
      </Tooltip>
      <Modal
        open={open}
        onClose={() => {}}
        BackdropProps={{
          onClick: (e) => e.stopPropagation(),
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <AiFillCloseSquare
              fontSize={30}
              onClick={handleClose}
              color="#FC2947"
              style={{ cursor: "pointer" }}
            />
          </Box>
          <section style={{ width: "100%", height: "auto" }}>
            <article
              style={{
                width: "90%",
                height: "auto",
                margin: "0 auto",
                background: "#efefef",
              }}
            >
              <Paper
                variant="outlined"
                style={{ border: "2px solid #9BA4B5", borderRadius: "10px" }}
              >
                <Box
                  sx={{
                    width: "100%",
                    background: "#DDE6ED",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "2px solid #9BA4B5",
                    borderRadius: "10px 10px 0 0",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      color: "#081f37",
                      fontSize: {
                        xs: "15px",
                        sm: "20px",
                        md: "25px",
                      },
                      textTransform: "capitalize",
                      fontWeight: "600",
                      letterSpacing: "0.5px",
                      justifyContent: "center",
                      margin: "0 auto",
                    }}
                  >
                    User Comment
                  </Box>
                </Box>
                <form
                  onSubmit={handleSubmit}
                  style={{
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    padding: "1%",
                  }}
                >
                  <Grid container spacing={1} item={12}>
                    <Grid md={12} xs={12} style={{ marginTop: "0.5%" }}>
                      <Item>
                        <TextareaAutosize
                          name="comment"
                          minRows={3}
                          style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "16px",
                            borderColor: "rgba(0, 0, 0, 1)",
                            borderRadius: "4px",
                            outline: "none",
                            borderWidth: "2px",
                            boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
                          }}
                          placeholder="Comment"
                          value={comment}
                          onChange={(e) => setComment(e.target.value)}
                        />
                      </Item>
                    </Grid>

                    <Grid item container md={12} spacing={2}>
                      <Grid item md={1.5}>
                        <Button
                          type="submit"
                          color="primary"
                          variant="contained"
                          style={btnstyle}
                          fullWidth
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </article>
          </section>
        </Box>
      </Modal>
    </div>
  );
}
